<template>
  <div class="tag-list">
    <div @click="onClick(tag)" v-for="tag in tags" :key="tag.id" :class="{'active': !!activeTag && tag.id == activeTag}" class="tag-item">
      <i class="fal fa-tag" :style="{ color: statistic[tag.id].hex_color || '#000000'}"></i>
      <span>{{tag.name}}</span>
      <div v-if="statistic[tag.id]">{{statistic[tag.id].revenue}} / {{statistic[tag.id].expense}}</div>
      <b-dropdown v-if="!readonly" size="sm" offset="-110" variant="link" toggle-class="text-decoration-none" no-caret>
        <template #button-content>
          <i class="fal fa-ellipsis-v"></i>
        </template>
        <b-dropdown-item href="#" @click="onClickEdit(tag)"><i class="far fa-edit mr-3"></i>{{$t('app.edit')}}</b-dropdown-item>
        <b-dropdown-item href="#" @click="onClickDelete(tag)"><i class="fal fa-trash mr-3"></i>{{$t('app.delete')}}</b-dropdown-item>
      </b-dropdown>
    </div>
  </div>
</template>

<script>

import { mapActions, mapState } from 'vuex';

export default {
  name: 'TagList',
  components: {
  },
  props: {
    tags: Array,
    activeTag: {},
    readonly: {
      type: Boolean,
      default: false,
    },
    shareTag: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {};
  },
  computed: {
    ...mapState({
      statistic: state => state.appStatistics.tags,
    }),
  },
  methods: {
    ...mapActions(['deleteTag']),
    onClick(tag) {
      if (this.activeTag && (tag.id === this.activeTag.id)) {
        return;
      }
      this.$emit('on-click', tag);
    },
    onClickEdit(tag) {
      this.$modal.show('tag-modal', { model: tag });
    },
    onClickDelete(tag) {
      this.$modal.show('dialog', {
        title: this.$t('tag.deleteTag'),
        text: this.$t('tag.deleteTagConfirmMsg'),
        okText: this.$t('app.delete'),
        okClass: 'btn btn-danger btn-sm',
        onOk: () => {
          this.deleteTag(tag.id).then(() => {
            this.$router.push({ name: 'main.dashboard', query: this.$route.query }).catch(() => {});
          });
        },
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/portal-components/tag/tag-list.vue